export const usersNamesToUsersEmails = (
    usersNames: string[],
    nameToEmail: Record<string, string>,
): string[] => {
    return usersNames.map(name => nameToEmail?.[name] || name);
};
